module.exports = __webpack_public_path__ + "img/04.1216ede6.svg";